var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"capabilities-container"},_vm._l((_vm.capabilities),function(capability,index){return _c('CapabilityCard',{key:index,attrs:{"capability":capability,"showNotLinked":_vm.showNotLinked}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }